export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-amber-50 via-white to-orange-50">
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-64 h-64 bg-amber-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-400 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-3 mb-8 bg-white/80 backdrop-blur-sm px-5 py-3 rounded-full shadow-md">
              <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
                <i className="ri-home-heart-line text-amber-600 text-lg"></i>
              </div>
              <span className="text-sm font-semibold text-gray-700">Handmade with Love Since 2020</span>
            </div>
            
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              Made by
              <br />
              <span className="text-amber-600">Two Hands,</span>
              <br />
              One Home
            </h1>
            
            <p className="text-lg text-gray-600 mb-10 leading-relaxed max-w-xl">
              Every piece we create is crafted in our home workshop, where passion meets craftsmanship. Our hands shape wood into treasures that become part of your home.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#products"
                className="bg-amber-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-amber-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-hand-heart-line mr-2 text-xl"></i>
                Explore Our Crafts
              </a>
              <a
                href="#contact"
                className="bg-white text-gray-900 border-2 border-gray-300 px-8 py-4 rounded-full text-base font-semibold hover:border-amber-600 hover:text-amber-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-home-smile-line mr-2 text-xl"></i>
                Custom Orders
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 flex items-center gap-8">
              <div className="flex items-center gap-2">
                <i className="ri-hand-heart-fill text-amber-600 text-2xl"></i>
                <div>
                  <div className="text-2xl font-bold text-gray-900">500+</div>
                  <div className="text-xs text-gray-600">Handmade Pieces</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-home-heart-fill text-amber-600 text-2xl"></i>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100%</div>
                  <div className="text-xs text-gray-600">Family Crafted</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Large Logo Display */}
          <div className="relative">
            <div className="relative bg-white rounded-3xl shadow-2xl p-12 border border-gray-100">
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-amber-100 rounded-full blur-2xl opacity-60"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-orange-100 rounded-full blur-2xl opacity-60"></div>
              
              <img
                src="https://static.readdy.ai/image/9e0ec1f08df5eac0f8e6ee60a23adb36/71c80160d04a459cf0ff28e8673272c6.png"
                alt="Tello Crafts - Two hands creating a home"
                className="w-full h-auto relative z-10"
              />
              
              <div className="mt-8 text-center relative z-10">
                <p className="text-sm text-gray-600 italic leading-relaxed">
                  "Two hands coming together to form a home - symbolizing our commitment to creating pieces that become part of your family story"
                </p>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-8 -left-8 bg-white rounded-2xl shadow-lg p-4 animate-float">
              <i className="ri-hammer-line text-3xl text-amber-600"></i>
            </div>
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-lg p-4 animate-float-delayed">
              <i className="ri-paint-brush-line text-3xl text-amber-600"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
